import {
  FieldWrapper,
  Input,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@commenda/kakashi';
import {
  FieldRefSource,
  TDataSourceCall,
  TValueProvider,
  TWorkflowBaseStepDefinition,
} from '@commenda/types';
import { ExprEditor } from './ExperssionEditor';
import { FieldRefEditor } from './FieldRefEditor';
import {
  getDefaultConstObj,
  getDefaultExprObj,
  getDefaultFieldRefObj,
} from './helpers';

export const ValueProviderEditor = ({
  value,
  onChange,
  steps = [],
  dataSources = [],
  allowedFieldRefSources,
}: {
  value: TValueProvider;
  onChange: (next: TValueProvider) => void;
  steps: TWorkflowBaseStepDefinition[];
  dataSources: TDataSourceCall[];
  allowedFieldRefSources?: FieldRefSource[];
}) => {
  const type = value?.type;

  return (
    <div className="my-4 flex flex-col gap-2">
      <FieldWrapper>
        <Label>Provider</Label>
        <Select
          value={type}
          onValueChange={(t: any) => {
            if (t === 'const') onChange(getDefaultConstObj());
            if (t === 'field') onChange(getDefaultFieldRefObj());
            if (t === 'expr') onChange(getDefaultExprObj());
          }}
        >
          <SelectTrigger>
            <SelectValue className="text-text-primary txt-medium-regular" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="const">const</SelectItem>
            <SelectItem value="field">field</SelectItem>
            <SelectItem value="expr">expr</SelectItem>
          </SelectContent>
        </Select>
      </FieldWrapper>

      {type === 'const' && (
        <FieldWrapper>
          <Label>Value</Label>
          <Input
            value={typeof value.value === 'string' ? value.value : ''}
            onChange={(e) => onChange({ type: 'const', value: e.target.value })}
          />
        </FieldWrapper>
      )}

      {type === 'field' && (
        <FieldRefEditor
          value={value.ref}
          onChange={(ref) => onChange({ type: 'field', ref })}
          steps={steps}
          dataSources={dataSources}
          allowedSources={allowedFieldRefSources}
        />
      )}

      {type === 'expr' && (
        <ExprEditor
          value={value.expr}
          onChange={(expr) => onChange({ type: 'expr', expr })}
        />
      )}
    </div>
  );
};
